import { render, staticRenderFns } from "./TrainingsFormPage.vue?vue&type=template&id=78cdc3bc&"
import script from "./TrainingsFormPage.vue?vue&type=script&lang=js&"
export * from "./TrainingsFormPage.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports